/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { AnsweredCommentsContainer_settings$ref } from "./AnsweredCommentsContainer_settings.graphql";
import { AnsweredCommentsContainer_story$ref } from "./AnsweredCommentsContainer_story.graphql";
import { AnsweredCommentsContainer_viewer$ref } from "./AnsweredCommentsContainer_viewer.graphql";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "DOWNVOTE_DESC" | "REPLIES_DESC" | "UPVOTE_DESC" | "%future added value";
export type AnsweredCommentsQueryVariables = {
    readonly storyID?: string | null;
    readonly storyURL?: string | null;
    readonly commentsOrderBy?: COMMENT_SORT | null;
};
export type AnsweredCommentsQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": AnsweredCommentsContainer_viewer$ref;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": AnsweredCommentsContainer_story$ref;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": AnsweredCommentsContainer_settings$ref;
    };
};
export type AnsweredCommentsQuery = {
    readonly response: AnsweredCommentsQueryResponse;
    readonly variables: AnsweredCommentsQueryVariables;
};



/*
query AnsweredCommentsQuery(
  $storyID: ID
  $storyURL: String
  $commentsOrderBy: COMMENT_SORT
) {
  viewer {
    ...AnsweredCommentsContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL) {
    ...AnsweredCommentsContainer_story_H4pgm
    id
  }
  settings {
    ...AnsweredCommentsContainer_settings
    id
  }
}

fragment AnsweredCommentsContainer_viewer on User {
  ...AnsweredCommentContainer_viewer
  ...IgnoredTombstoneOrHideContainer_viewer
  status {
    current
  }
}

fragment AnsweredCommentsContainer_story_H4pgm on Story {
  id
  featuredComments(first: 5, orderBy: $commentsOrderBy) {
    edges {
      node {
        id
        ...AnsweredCommentContainer_comment
        ...IgnoredTombstoneOrHideContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...PostCommentFormContainer_story
  ...AnsweredCommentContainer_story
}

fragment AnsweredCommentsContainer_settings on Settings {
  reaction {
    sortLabel
  }
  ...AnsweredCommentContainer_settings
}

fragment AnsweredCommentContainer_settings on Settings {
  ...ReactionButtonContainer_settings
  ...UserTagsContainer_settings
  ...CommentContainer_settings
}

fragment ReactionButtonContainer_settings on Settings {
  reaction {
    label
    labelActive
    icon
    iconActive
  }
}

fragment UserTagsContainer_settings on Settings {
  staff {
    label
  }
}

fragment CommentContainer_settings on Settings {
  disableCommenting {
    enabled
  }
  ...ReactionButtonContainer_settings
  ...ReplyCommentFormContainer_settings
  ...EditCommentFormContainer_settings
  ...UserTagsContainer_settings
}

fragment ReplyCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
}

fragment EditCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
}

fragment AnsweredCommentContainer_comment on Comment {
  id
  author {
    id
    username
  }
  parent {
    author {
      username
      id
    }
    ...CommentContainer_comment
    id
  }
  body
  createdAt
  replyCount
  ...UsernameWithPopoverContainer_comment
  ...ReactionButtonContainer_comment
  ...UserTagsContainer_comment
}

fragment IgnoredTombstoneOrHideContainer_comment on Comment {
  author {
    id
    username
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  ...MessageBoxContainer_story
  settings {
    messageBox {
      enabled
    }
    mode
  }
}

fragment AnsweredCommentContainer_story on Story {
  url
  ...UserTagsContainer_story
  ...CommentContainer_story
}

fragment UserTagsContainer_story on Story {
  settings {
    mode
  }
}

fragment CommentContainer_story on Story {
  url
  isClosed
  settings {
    mode
  }
  ...CaretContainer_story
  ...ReplyCommentFormContainer_story
  ...PermalinkButtonContainer_story
  ...EditCommentFormContainer_story
  ...UserTagsContainer_story
}

fragment CaretContainer_story on Story {
  ...ModerationDropdownContainer_story
}

fragment ReplyCommentFormContainer_story on Story {
  id
  isClosed
}

fragment PermalinkButtonContainer_story on Story {
  url
}

fragment EditCommentFormContainer_story on Story {
  id
}

fragment ModerationDropdownContainer_story on Story {
  id
  ...ModerationActionsContainer_story
  ...UserBanPopoverContainer_story
}

fragment ModerationActionsContainer_story on Story {
  id
  settings {
    mode
  }
}

fragment UserBanPopoverContainer_story on Story {
  id
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment CommentContainer_comment on Comment {
  id
  author {
    id
    username
  }
  parent {
    author {
      username
      id
    }
    id
  }
  body
  createdAt
  status
  editing {
    edited
    editableUntil
  }
  tags {
    code
  }
  deleted
  ...ReplyCommentFormContainer_comment
  ...EditCommentFormContainer_comment
  ...ReactionButtonContainer_comment
  ...ReportButtonContainer_comment
  ...CaretContainer_comment
  ...RejectedTombstoneContainer_comment
  ...AuthorBadgesContainer_comment
  ...UserTagsContainer_comment
  ...UsernameWithPopoverContainer_comment
}

fragment UsernameWithPopoverContainer_comment on Comment {
  id
  author {
    id
    username
    ...UserPopoverContainer_user
  }
}

fragment ReactionButtonContainer_comment on Comment {
  id
  revision {
    id
  }
  viewerActionPresence {
    reaction
    upvote
    downvote
  }
  actionCounts {
    reaction {
      total
    }
    upvote {
      total
    }
    downvote {
      total
    }
  }
}

fragment UserTagsContainer_comment on Comment {
  tags {
    code
  }
}

fragment UserPopoverContainer_user on User {
  id
  ...UserPopoverOverviewContainer_user
  ...UserIgnorePopoverContainer_user
}

fragment UserPopoverOverviewContainer_user on User {
  id
  username
  createdAt
  ignoreable
}

fragment UserIgnorePopoverContainer_user on User {
  id
  username
}

fragment ReplyCommentFormContainer_comment on Comment {
  id
  author {
    username
    id
  }
  revision {
    id
  }
}

fragment EditCommentFormContainer_comment on Comment {
  id
  body
  createdAt
  author {
    username
    id
  }
  editing {
    editableUntil
  }
}

fragment ReportButtonContainer_comment on Comment {
  ...ReportCommentFormContainer_comment
  id
  viewerActionPresence {
    dontAgree
    flag
  }
}

fragment CaretContainer_comment on Comment {
  id
  ...ModerationDropdownContainer_comment
}

fragment RejectedTombstoneContainer_comment on Comment {
  id
}

fragment AuthorBadgesContainer_comment on Comment {
  author {
    badges
    id
  }
}

fragment ModerationDropdownContainer_comment on Comment {
  id
  author {
    id
    username
  }
  revision {
    id
  }
  status
  tags {
    code
  }
  ...ModerationActionsContainer_comment
  ...UserBanPopoverContainer_comment
}

fragment ModerationActionsContainer_comment on Comment {
  id
  author {
    id
  }
  revision {
    id
  }
  status
  tags {
    code
  }
}

fragment UserBanPopoverContainer_comment on Comment {
  id
  revision {
    id
  }
  status
  author {
    id
    username
  }
}

fragment ReportCommentFormContainer_comment on Comment {
  id
  revision {
    id
  }
}

fragment AnsweredCommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  role
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...CommentContainer_viewer
}

fragment IgnoredTombstoneOrHideContainer_viewer on User {
  ignoredUsers {
    id
  }
}

fragment UsernameWithPopoverContainer_viewer on User {
  ...UserPopoverContainer_viewer
}

fragment ReactionButtonContainer_viewer on User {
  id
}

fragment CommentContainer_viewer on User {
  id
  status {
    current
  }
  ignoredUsers {
    id
  }
  badges
  role
  scheduledDeletionDate
  ...UsernameWithPopoverContainer_viewer
  ...ReactionButtonContainer_viewer
  ...ReportButtonContainer_viewer
  ...CaretContainer_viewer
}

fragment ReportButtonContainer_viewer on User {
  id
}

fragment CaretContainer_viewer on User {
  ...ModerationDropdownContainer_viewer
}

fragment ModerationDropdownContainer_viewer on User {
  ...ModerationActionsContainer_viewer
}

fragment ModerationActionsContainer_viewer on User {
  id
}

fragment UserPopoverContainer_viewer on User {
  ...UserPopoverOverviewContainer_viewer
}

fragment UserPopoverOverviewContainer_viewer on User {
  id
  ignoredUsers {
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "storyID",
            "type": "ID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "storyURL",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "commentsOrderBy",
            "type": "COMMENT_SORT",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v2 = ({
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "commentsOrderBy"
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = [
        (v3 /*: any*/)
    ], v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "badges",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 5
        } as any),
        (v2 /*: any*/)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "username",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "ignoreable",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "body",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "tags",
        "storageKey": null,
        "args": null,
        "concreteType": "Tag",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "revision",
        "storageKey": null,
        "args": null,
        "concreteType": "CommentRevision",
        "plural": false,
        "selections": (v4 /*: any*/)
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "reaction",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "upvote",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "downvote",
        "args": null,
        "storageKey": null
    } as any), v16 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
        } as any)
    ], v17 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "actionCounts",
        "storageKey": null,
        "args": null,
        "concreteType": "ActionCounts",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "reaction",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v16 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "upvote",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v16 /*: any*/)
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "downvote",
                "storageKey": null,
                "args": null,
                "concreteType": "ReactionActionCounts",
                "plural": false,
                "selections": (v16 /*: any*/)
            }
        ]
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastViewerAction",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "icon",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enabled",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "label",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "AnsweredCommentsQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_viewer",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": "story",
                    "name": "stream",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_story",
                            "args": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "AnsweredCommentsContainer_settings",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "AnsweredCommentsQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "status",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "current",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ignoredUsers",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": true,
                            "selections": (v4 /*: any*/)
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "role",
                            "args": null,
                            "storageKey": null
                        },
                        (v5 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "scheduledDeletionDate",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": "story",
                    "name": "stream",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "featuredComments",
                            "storageKey": null,
                            "args": (v6 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "plural": false,
                                            "selections": [
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "author",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "User",
                                                    "plural": false,
                                                    "selections": [
                                                        (v3 /*: any*/),
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "parent",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "author",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v3 /*: any*/),
                                                                (v5 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/)
                                                            ]
                                                        },
                                                        (v3 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "parent",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Comment",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "author",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "User",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v3 /*: any*/)
                                                                    ]
                                                                },
                                                                (v3 /*: any*/)
                                                            ]
                                                        },
                                                        (v10 /*: any*/),
                                                        (v8 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "status",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "editing",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "EditInfo",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "edited",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "editableUntil",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        (v11 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "deleted",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v12 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "viewerActionPresence",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ActionPresence",
                                                            "plural": false,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v15 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "dontAgree",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "flag",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        (v17 /*: any*/),
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "pending",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v18 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v10 /*: any*/),
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "replyCount",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v12 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "viewerActionPresence",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ActionPresence",
                                                    "plural": false,
                                                    "selections": [
                                                        (v13 /*: any*/),
                                                        (v14 /*: any*/),
                                                        (v15 /*: any*/)
                                                    ]
                                                },
                                                (v17 /*: any*/),
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "__typename",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        (v18 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "cursor",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "pageInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "endCursor",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hasNextPage",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedHandle",
                            "alias": null,
                            "name": "featuredComments",
                            "args": (v6 /*: any*/),
                            "handle": "connection",
                            "key": "Stream_featuredComments",
                            "filters": [
                                "orderBy"
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isClosed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "settings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "messageBox",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "content",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v19 /*: any*/),
                                        (v20 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mode",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "reaction",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sortLabel",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v21 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "labelActive",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v19 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "iconActive",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "staff",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StaffConfiguration",
                            "plural": false,
                            "selections": [
                                (v21 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "disableCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "plural": false,
                            "selections": [
                                (v20 /*: any*/),
                                (v22 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "charCount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "plural": false,
                            "selections": [
                                (v20 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "min",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "max",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "closeCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "plural": false,
                            "selections": [
                                (v22 /*: any*/)
                            ]
                        },
                        (v3 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "AnsweredCommentsQuery",
            "id": "b1521bbd64185152b0bd8b7100391ad0",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cbe73b44a2b05efaa15de6e8f2740320';
export default node;
